export const data = [
  {
    author: "Jose Thomas",
    feedback:
      "RESPECTED Dr. Lalit had done my father Mr. M.J. Thomas right eye surgery today. There was cordial, lively, lovely care from Dr. Lalit personally and also from all the staff of Amrit Hospital. The sincere and cordial response from Insurance staff of the hospital was noteworthy especially Gomthy madam and Julie madam. Thank you very much.",
  },
  {
    author: "Mohammed Saif",
    feedback:
      "We have done hypospadias surgery for our son. Good care by our doctor Raghul, Paediatric surgeon. And the hospital staff are very good & took great care of our son.",
  },
  {
    author: "Satish Kumar",
    feedback:
      "They provide good treatment at an affordable cost, which is lacking in most hospitals nowadays. Definitely, I will recommend this hospital for ophthalmology issues to friends and families. They also have many modern diagnostic devices to check our eyes.",
  },
  {
    author: "Neepa Patira",
    feedback:
      "We are very much satisfied with this hospitality. Dr. Sonali and Dr. Hugmi are both gem persons, and we are very thankful to both of them as well as all team members.",
  },
  {
    author: "Mahalakshmi B",
    feedback:
      "I got my smile pro done here by Dr. Lalit Kumar. He is a very humble and positive person. I was well guided at every stage by the hospital staff. Altogether, they made my journey a seamless process. Satisfied with the results.",
  },
  {
    author: "Rahul Sewag",
    feedback:
      "Doctors and nursing staff took good care of my son while he was admitted to the hospital recovering from dengue. The sisters were very cooperative and friendly with my son. The hospital has almost all the scanning and blood testing lab facilities in-house.",
  },
  {
    author: "Sulthan S.M.",
    feedback:
      "Hi all, I had admitted my daughter under Dr. Sonal madam, who had been referred by my family doctor Dr. Mohammed Rafique. Dr. Sonal is a very good doctor who took good care of my daughter. The hospital is very clean, neat, and affordable. The sisters are good, caring, and provide good service. Thanks to Dr. Sonal and her team.",
  },
  {
    author: "Sunitha Bafna",
    feedback:
      "I had admitted my daughter under Dr. Chetan, and I should say he is such a wonderful doctor. Because of him, today my daughter is well and happy. Thanks to Amrit Medical Centre and Dr. Chetan.",
  },
  {
    author: "Yobu Paul",
    feedback:
      "The hospital is very neat and clean. My 2-year-old child had circumcision in this hospital. Dr. Ragul explained the issues very clearly. He is very cooperative in all aspects. He is very good. Nurses are doing a fantastic job. I never felt that I was in a hospital environment. Thank you, Amrit Hospital admin.",
  },
  {
    author: "Mudit Bohara",
    feedback:
      "My wife’s delivery was done here by Dr. Shalini, and after delivery, the paediatrician was Dr. Chetan. They took care of the mother and baby very well day and night for days. All the nurses and other helping staff in the hospital were very cooperative and kind. Highly recommended by me.",
  },
];
